export default __webpack_public_path__ + "static/hero-c140513af33d5cdc108cf050eceb454c.mp4";